/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';

export const page: {
  root: Item<'Page'>;
  flexItem0: Item<'FlexItem'>;
  flexPanel: Item<'FlexPanel'>;
  flexItem1: Item<'FlexItem'>;
  flexItem2: Item<'FlexItem'>;
  flexItem3: Item<'FlexItem'>;
  box: Item<'Box'>;
  box2: Item<'Box'>;
  box3: Item<'Box'>;
  text: Item<'Text'>;
} = {
  box: {
    children: ['text'],
    itemId: 'box',
    parent: 'flexItem0',
    props: {
      padding: {
        all: 40,
      },
    },
    type: 'Box',
  },
  box2: {
    children: ['text'],
    itemId: 'box2',
    parent: 'flexItem0',
    props: {
      padding: {
        all: 40,
      },
    },
    type: 'Box',
  },
  box3: {
    children: ['text'],
    itemId: 'box3',
    parent: 'flexItem0',
    props: {
      padding: {
        all: 40,
      },
    },
    type: 'Box',
  },
  flexItem0: {
    children: [],
    itemId: 'flexItem0',
    parent: 'flexPanel',
    props: {
      border: {
        all: {
          borderColor: { a: 1, b: 155, g: 155, r: 155 },
          style: 'solid',
          width: 8,
        },
      },
      sizeType: 'flex',
    },
    type: 'FlexItem',
  },
  flexItem1: {
    children: [],
    itemId: 'flexItem1',
    parent: 'flexPanel',
    props: {
      border: {
        all: {
          borderColor: { a: 1, b: 155, g: 155, r: 155 },
          style: 'solid',
          width: 8,
        },
      },
    },
    type: 'FlexItem',
  },
  flexItem2: {
    children: [],
    itemId: 'flexItem2',
    parent: 'flexPanel',
    props: {
      border: {
        all: {
          borderColor: { a: 1, b: 155, g: 155, r: 155 },
          style: 'solid',
          width: 8,
        },
      },
    },
    type: 'FlexItem',
  },
  flexItem3: {
    children: [],
    itemId: 'flexItem3',
    parent: 'flexPanel',
    props: {
      border: {
        all: {
          borderColor: { a: 1, b: 155, g: 155, r: 155 },
          style: 'solid',
          width: 8,
        },
      },
    },
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem0', 'flexItem1', 'flexItem3', 'flexItem2'],
    itemId: 'flexPanel',
    parent: 'root',
    props: {
      border: {
        all: {
          style: 'solid',
          width: 0,
        },
      },
      renderAs: 'columns',
    },
    type: 'FlexPanel',
  },
  root: {
    children: ['flexPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
  text: {
    children: [],
    itemId: 'text',
    parent: 'box',
    props: {
      text: {
        type: 'text',
        value: 'Content',
      },
    },
    type: 'Text',
  },
};
